import { createEffect } from 'effector';

import { apiFetch } from '@m/utils/http';

export const fetchForceCloseReasons = createEffect({
  handler: ({ visitId }: { visitId?: number } = {}) =>
    apiFetch('/specialist/visits/force-close-reasons', {
      params: visitId ? { visitId } : undefined,
    }),
});

export const forceCloseVisit = createEffect({
  handler: async ({
    visitId,
    forceCloseReasonId,
  }: {
    forceCloseReasonId: number;
    visitId: number;
  }) =>
    apiFetch(`/specialist/visit/${visitId}/force-close`, {
      method: 'POST',
      body: {
        forceCloseReason: { id: forceCloseReasonId },
      },
    }),
});
